import { render, staticRenderFns } from "./OrganizationsComponent.vue?vue&type=template&id=3e3578df&scoped=true"
import script from "./OrganizationsComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3578df",
  null
  
)

export default component.exports